import { BusinessPremises }      from '@app/modules/business-premises/models/business-premises.model';
import { BusinessPremisesState } from '@app/modules/business-premises/store/business-premises.state';
import { ImportTypeEnum }        from '@app/modules/structure-import/models/structure-import.model';
import { ActionTypeWithProps }   from '@core/interfaces/store.interface';
import {
	adapterActions,
	IAdapterActions,
	IBaseProps
}                                from '@core/store/adapter/adapter.actions';
import {
	createAction,
	props
}                                from '@ngrx/store';


export interface IBusinessPremisesActions extends IAdapterActions<BusinessPremises> {
	checkAndUpdateEntityState: ActionTypeWithProps<IPropsBusinessPremisesEntity>;
	requestTssForBusinessPremisesAfterCreate: ActionTypeWithProps<IPropsBusinessPremisesEntity>;
	showBusinessPremisesConfig: ActionTypeWithProps<IPropsBusinessPremisesEntity>;
	structureExportForBusinessPremises: ActionTypeWithProps<IPropsBusinessPremisesEntity>;
	structureImportForBusinessPremises: ActionTypeWithProps<IPropsImportForBusinessPremises>;
	taxationReportingCreateForBusinessPremises: ActionTypeWithProps<IPropsBusinessPremisesEntity>;
	updateBusinessPremisesState: ActionTypeWithProps<IPropsUpdateBusinessPremisesState>;
}


export interface IPropsUpdateBusinessPremisesState extends IBaseProps {
	stateUpdateData?: BusinessPremisesState;
}

export interface IPropsImportForBusinessPremises extends IBaseProps {
	importType: ImportTypeEnum.BUSINESS_PREMISES;
}

export interface IPropsBusinessPremisesEntity extends IBaseProps {
	businessPremises: BusinessPremises;
	refreshList?: boolean
}

export function businessPremisesActions( storeId: string ) {
	return {
		// AdapterActions ##########################################################################################################################
		...adapterActions<BusinessPremises>( storeId ),

		// BUSINESS PREMISES SPECIFIC ACTIONS ###########################################################################################################
		checkAndUpdateEntityState: createAction( `[${ storeId }] checkAndUpdateEntityState`, props<IPropsBusinessPremisesEntity>() ),
		requestTssForBusinessPremisesAfterCreate: createAction(
			`[${ storeId }] Request TSS for BusinessPremises after create`, props<IPropsBusinessPremisesEntity>() ),
		showBusinessPremisesConfig: createAction( `[${ storeId }] BusinessPremises config`, props<IPropsBusinessPremisesEntity>() ),
		structureExportForBusinessPremises: createAction( `[${ storeId }] StructureExport`, props<IPropsBusinessPremisesEntity>() ),
		structureImportForBusinessPremises: createAction( `[${ storeId }] StructureImport`, props<IPropsImportForBusinessPremises>() ),
		taxationReportingCreateForBusinessPremises: createAction( `[${ storeId }] TaxationReporting Create`, props<IPropsBusinessPremisesEntity>() ),
		updateBusinessPremisesState: createAction( `[${ storeId }] State Update`, props<IPropsUpdateBusinessPremisesState>() )
	};
}

